import { css } from '@emotion/react';
import { forwardRef } from 'react';

import IconAddFilled from '~icons/carbon/add-filled';

import { theme } from '@adflow/frontend/ui-theme';

import type { LinkNavActionProps } from './nav-action';
import { LinkNavAction } from './nav-action';

const styles = {
	addButton: css({
		'&[data-disabled=true]': css({
			color: theme.colors.action.disabledBackground,
			cursor: 'default',

			svg: css({
				color: theme.colors.action.disabledBackground,
			}),
			'svg:active': { filter: 'none' },
		}),
	}),
	icon: css({
		color: theme.colors.palettes.primary.main,
		width: 26,
		height: 26,
		'&:active': {
			filter: 'brightness(81%)',
		},
	}),
	smallIcon: css({
		width: 18,
		height: 18,
	}),
};

export interface LinkIconAddProps extends LinkNavActionProps {
	small?: boolean;
}

export const LinkIconAdd = forwardRef<HTMLAnchorElement, LinkIconAddProps>(
	function LinkIconAddRender({ small = false, ...forwardedProps }, ref) {
		return (
			<LinkNavAction
				data-testid="button-icon-add"
				{...forwardedProps}
				ref={ref}
				css={styles.addButton}
			>
				<IconAddFilled
					css={[
						styles.icon,
						small && styles.smallIcon,
						{ pointerEvents: 'none' },
					]}
				/>
			</LinkNavAction>
		);
	}
);
